/**
 * Checks whether a string contains a specified value, ignoring case sensitivity.
 *
 * @param {any} inputString - The main string in which the search is performed.
 *                            Non-string values will be converted to a string
 * @param {any} substring - The string to search for within the main string.
 *                          Non-string values will be converted to a string
 * @returns {boolean} - Returns `true` if the `substring` is found within the `inputString`,
 *                      otherwise `false`.
 */

export default function textIncludes(inputString, substring) {
  const normalizedInputString = String(inputString).trim().toLowerCase();
  const normalizedSubstring = String(substring).trim().toLowerCase();

  return normalizedInputString.includes(normalizedSubstring);
}
